import { useQuery } from '@tanstack/react-query'
import { appDatabasesQuery } from '../api/sqlDatabases'

/**
 * Sub o componenta Database a aplicatiei: bazele ei de pe masina aceea, din
 * ce a citit agentul de Windows - "database CHARISMA_PROD, 42 GB, last full
 * backup 2026-10-04". O cerere pe aplicatie (toate componentele o impart).
 * Fara baze citite nu se deseneaza nimic.
 */
export function AppComponentDatabases({ appId, deviceId }: { appId: number; deviceId: number }) {
  const { data } = useQuery({ ...appDatabasesQuery(appId), retry: false })
  const mine = (data?.databases ?? []).filter((d) => d.deviceId === deviceId)
  if (mine.length === 0) return null

  return (
    <div className="adm-muted small app-component-dbs">
      {mine.map((d) => (
        <div key={`${d.instance}:${d.name}`} title={`instance ${d.instance}`}>
          <i className="fas fa-database" aria-hidden="true"></i> {d.label}
        </div>
      ))}
    </div>
  )
}
